import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_plank text_whitegreen">
      <div className="home_vid">
        <video muted loop autoPlay id="myVideo" playsInline>
          <source
            src="https://d3r5yd0374231.cloudfront.net/images-tek/assets/images-new/case-studies/pure-plank/banner-vid-pure-plank.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={11}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <div className="banner_content">
              <div className="banner_logo">
                <StaticImage
                  src="../../../images/case-studies/pure-plank/logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={334}
                  height={152}
                />
              </div>
              <p>
                Pure Plank is an online platform for fitness and exercise
                enthusiasts aiming to look after their health and exercise at
                home. With video tutorials and challenges, this platform brings
                a new idea to life.
              </p>
              <p>
                TekRevol has developed several digital solutions, including
                mobile apps, pertaining to the fitness and healthcare sector.
                With the experience gained from previous projects, we developed
                this unique solution that is focused on providing guidance
                regarding planks – one of the most notable exercises.
              </p>
              <div className="banner_btn">
                <Link to="https://apps.apple.com/us/app/pure-plank/id1613334264">
                  <StaticImage
                    src="../../../images/case-studies/pure-plank/app_white.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={212}
                    height={80}
                  />
                </Link>
                <Link to="https://play.google.com/store/apps/details?id=com.pureplank">
                  <StaticImage
                    src="../../../images/case-studies/pure-plank/google_white.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={206}
                    height={80}
                  />
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
